import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ISignupSetPasscode, ISignupSetPasscodeResponse } from '../models/signup-set-passcode.model';

export const loadSignupSetPasscodes = createAction('[SignupSetPasscode] Load SignupSetPasscodes', props<{ request: ISignupSetPasscode }>());

export const loadSignupSetPasscodesSuccess = createAction(
  '[SignupSetPasscode] Load SignupSetPasscodes Success',
  props<{ response: ISignupSetPasscodeResponse }>()
);

export const loadSignupSetPasscodesFailure = createAction(
  '[SignupSetPasscode] Load SignupSetPasscodes Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
